import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { quoteThumbnailRefetchInterval } from '../model/thumbnail-polling';

interface MyQuotesQueryInput {
  readonly page: number;
}

/**
 * 내 견적 목록(quotes.listMine) — 페이지 번호 페이지네이션, 페이지 크기는 서버 기본값.
 * 페이지를 바꾸는 동안 이전 페이지를 자리표시자로 유지해 표가 로딩 문구로 바뀌지 않는다.
 */
export const useMyQuotesQuery = ({ page }: MyQuotesQueryInput) =>
  trpc.quotes.listMine.useQuery(
    { page },
    {
      placeholderData: keepPreviousData,
      // 방금 요청한 견적의 그림이 생길 때까지 잠깐 다시 조회한다(마이페이지 최근 견적도 이 훅을 쓴다).
      refetchInterval: (query) => {
        const loaded = query.state.data;
        return loaded
          ? quoteThumbnailRefetchInterval(loaded.items, Date.now(), query.state)
          : false;
      },
    },
  );
